import React from "react";
import { CSSTransition } from "react-transition-group";
import { Toast } from "primereact/toast";
import DocumentUploadItem from "../DocumentUploadItem/DocumentUploadItem";
import "./DocumentUploadList.css";

const DocumentUploadList = ({
  documents,
  groupName = "",
  uploadedDocs,
  toastRef,
  ownerSignedTitleImage,
  odometerInTitleImage,
  signedLRInTitleImage,
  setOwnerSignedTitleImage = () => {},
  setOdometerInTitleImage = () => {},
  setSignedLRInTitleImage = () => {},
  setOdometerInMVR = () => {},
  handleDocuments = () => {},
  docsBeingUploaded
}) => {
  return (
    <div className="DocumentSection">
      {groupName.length > 0 && (
        <CSSTransition
          in={documents.length > 0}
          timeout={500}
          classNames="group-label"
          unmountOnExit
        >
          <div className="GroupLabel">
            <div className="GroupText">{groupName}</div>
          </div>
        </CSSTransition>
      )}
      <div className="DocUploadList">
        <Toast ref={toastRef} position={"top-right"} baseZIndex={10000}></Toast>
        {documents.length > 0 &&
          documents.map((doc, i) => {
            return (
              <DocumentUploadItem
                key={`${doc.label}${i}`}
                doc={doc}
                uploadedDocs={uploadedDocs}
                docsBeingUploaded={docsBeingUploaded}
                ownerSignedTitleImage={ownerSignedTitleImage}
                setOwnerSignedTitleImage={setOwnerSignedTitleImage}
                odometerInTitleImage={odometerInTitleImage}
                setOdometerInTitleImage={setOdometerInTitleImage}
                signedLRInTitleImage={signedLRInTitleImage}
                setSignedLRInTitleImage={setSignedLRInTitleImage}
                setOdometerInMVR={setOdometerInMVR}
                handleDocuments={handleDocuments}
              />
            );
          })}
      </div>
    </div>
  );
};

export default DocumentUploadList;
